import { render, staticRenderFns } from "./BuildPooledPolicies.vue?vue&type=template&id=18219796&scoped=true"
import script from "./BuildPooledPolicies.vue?vue&type=script&lang=js"
export * from "./BuildPooledPolicies.vue?vue&type=script&lang=js"
import style0 from "./BuildPooledPolicies.vue?vue&type=style&index=0&id=18219796&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18219796",
  null
  
)

export default component.exports